<template>
  <div class="doughnut-chart" ref="doughnutChartContainer"></div>
</template>

<script>
import { Chart, Title, Tooltip, Legend, ArcElement, DoughnutController } from 'chart.js'

Chart.register(Title, Tooltip, Legend, ArcElement, DoughnutController)

export default {
  name: 'DoughnutChart',
  props: ["chartData", "chartOptions", "chartId"],
  watch: {
    chartData() {
      this.createChart()
    },
  },
  methods: {
    createChart() {
      if (document.getElementById(this.chartId)) {
        this.$refs.doughnutChartContainer.removeChild(document.getElementById(this.chartId))
      }
      
      const canvas = document.createElement('canvas');
      canvas.id = this.chartId;
      this.$refs.doughnutChartContainer.appendChild(canvas);

      const ctx = document.getElementById(this.chartId)
      new Chart(ctx, {
        type: 'doughnut',
        options: this.chartOptions,
        data: {
          datasets: this.chartData.datasets,
          labels: this.chartData.labels,
        },
      });
    }
  },
  mounted() {
    this.createChart()
  },
}
</script>